import { chakra, Checkbox as ChakraCheckbox } from '@chakra-ui/react'

const Checkbox = chakra(ChakraCheckbox)
export default Checkbox
